import React from "react";
import { ListGroup } from "react-bootstrap";
import { useComponentVisible } from "../../shared/hooks/useComponentVisible";
import "./Wallet.css";

export default function AgentsDropdown({
  list,
  value,
  handleInputChange,
  handleItemClick,
  inputClassnames,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible();
  return (
    <>
      <input
        placeholder="Select Agent"
        value={value}
        className={inputClassnames}
        ref={ref}
        onClick={() => setIsComponentVisible(!isComponentVisible)}
        onChange={handleInputChange}
      />

      {isComponentVisible ? (
        <ListGroup className="dropdown-options-container w-100 bg-white">
          <ListGroup.Item
            className="text1-4 list-item"
            style={{
              cursor: "pointer",
            }}
            onClick={() => handleItemClick()}
          >
            Search All agents
          </ListGroup.Item>
          {list?.length ? (
            <>
              {list.map((item) => (
                <ListGroup.Item
                  className="text1-4 list-item"
                  style={{
                    cursor: "pointer",
                  }}
                  key={item.id}
                  onClick={() => {
                    handleItemClick(item);
                    setIsComponentVisible(!isComponentVisible);
                  }}
                >
                  {item.name}
                </ListGroup.Item>
              ))}
            </>
          ) : (
            <ListGroup.Item>No agents found</ListGroup.Item>
          )}
        </ListGroup>
      ) : null}
    </>
  );
}
